import { useContext, useEffect, useEffectEvent, useState } from 'react'
import { Link as RouterLink } from 'react-router'
import { PlaceOutlined } from '@mui/icons-material'
import { Box, CircularProgress, Link, Typography } from '@mui/material'
import { useSnackbar } from 'notistack'

import { AppContext, useHost } from '../../providers/app-provider'
import { useAuthentication } from '../../providers/auth-provider'
import Api from '../../utils/api'
import { formatAddress } from '../../utils/helpers'
import useDocumentTitle from '../../utils/hooks/useDocumentTitle'
import useSharedStyles from '../../utils/shared.styles'

import useStyles from './index.styles'

const NewlyAddedAccounts = () => {
  const { auth, ownUser } = useAuthentication()
  const host = useHost()
  const { tenantId, pageRefreshCounter } = useContext(AppContext)
  const { enqueueSnackbar } = useSnackbar()
  const classes = useStyles
  const sharedClasses = useSharedStyles

  useDocumentTitle('Meshify Central')

  const [loading, setLoading] = useState<boolean>(true)
  const [folders, setFolders] = useState<IFolderType[]>([])

  const fetchData = useEffectEvent(async () => {
    if (!host || !auth.user?.access_token || !ownUser) return
    setLoading(true)
    const res = await Api.post(`${host}/api/folders/query?detail=true`, {
      filters: [{ fieldName: 'type', operator: 'eq', value: 'Participant' }],
      orderBy: 'createdAt',
      orderDirection: 'desc',
      first: 50,
      type: 'and',
    })
    if (res.ok) {
      setFolders(res.body.results)
    } else {
      enqueueSnackbar('Something went wrong, and accounts did not load', { variant: 'error' })
    }
    setLoading(false)
  })
  useEffect(() => {
    fetchData()
  }, [ownUser, host, pageRefreshCounter])

  return (
    <>
      {loading ? (
        <Box sx={classes.loaderContainer}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Typography variant="body1">Showing the 50 most recent accounts</Typography>
          {folders.map((folder) => (
            <Box key={folder.id} sx={classes.folderItem}>
              <Link component={RouterLink} variant="body1" underline="hover" to={`/tenant/${tenantId}/accounts/${folder.id}`} sx={classes.folderLink}>
                {folder?.name}
              </Link>

              <Typography variant="body2" sx={classes.folderAddress} className="fs-exclude">
                <PlaceOutlined sx={classes.folderAddressIcon} />
                {formatAddress(folder.information.address, folder.information.address.country)}
              </Typography>

              <Typography variant="body2" sx={sharedClasses.secondaryText}>
                {folder.parentFolderName}
              </Typography>
            </Box>
          ))}
        </>
      )}
    </>
  )
}

export default NewlyAddedAccounts
